import app from "./../app";

var innerObject = {
  prepareSelectedHours: function (selectedHours) {
    var intervals = [];
    var interValIndex = 0;
    var showTimesIntervals = [];

    if (typeof selectedHours === "object" && selectedHours.length > 1) {
      selectedHours.sort(function (a, b) {
        return a - b;
      });

      selectedHours.some(function (item) {
        if (!intervals[interValIndex]) {
          intervals[interValIndex] = {};
          intervals[interValIndex].interval = [];
          intervals[interValIndex].interval.push(parseInt(item));
          intervals[interValIndex].checkValue = parseInt(item);
        } else if (intervals[interValIndex].checkValue !== undefined && intervals[interValIndex].checkValue + 1 == parseInt(item)) {
          intervals[interValIndex].checkValue = parseInt(item);
        } else {
          intervals[interValIndex].interval.push(intervals[interValIndex].checkValue + 1);
          interValIndex++;
          intervals[interValIndex] = {};
          intervals[interValIndex].interval = [];
          intervals[interValIndex].interval.push(parseInt(item));
          intervals[interValIndex].checkValue = parseInt(item);
        }
      });

      intervals[interValIndex].interval.push(intervals[interValIndex].checkValue + 1);

      intervals.forEach(function (interval) {
        showTimesIntervals.push(interval.interval[0]);
        showTimesIntervals.push(interval.interval[1]);
      });
    }
    if (typeof selectedHours === "number" || (typeof selectedHours === "string" && selectedHours.length)) {
      showTimesIntervals.push(selectedHours);
      showTimesIntervals.push(parseInt(selectedHours) + 1);
    }
    if (typeof selectedHours === "string" && !selectedHours.length) {
      showTimesIntervals = [];
    }
    return showTimesIntervals;
  },
  getHoursArrayByIntervalArray: function (hoursArray) {
    const selectedHoursByIntervals = [];

    for (let i = 0; i < hoursArray.length; i = i + 2) {
      for (let hour = hoursArray[i]; hour < hoursArray[i + 1]; hour++) {
        if (!hour) { //hack for webix components
          hour = "0";
        }
        selectedHoursByIntervals.push(hour);
      }
    }

    return selectedHoursByIntervals;
  }
};

var outputObject = {
  prepareSelectedHours: innerObject.prepareSelectedHours,
  getHoursArrayByIntervalArray: innerObject.getHoursArrayByIntervalArray,
};

export default outputObject;

